import React from "react";
import PropTypes from "prop-types";

const TableOptionsComponent = ({
    filename,
    count,
    page,
    rowsPerPage,
    setHeaderTitle,
    onChangePageEvent,
    onChangeRowsEvent,
    onChangeFilterEvent,
    onColumnSortChangeEvent,
}) => {
    return {
        responsive: "standard",
        filterType: "multiselect",
        filter: false,
        download: false,
        print: false,
        search: false,
        viewColumns: false,
        selectableRows: "none",
        downloadOptions: {
            filename: filename,
            separator: ",",
            filterOptions: { useDisplayedColumnsOnly: true },
        },
        onRowClick: (rowData) => {
            setHeaderTitle(`${rowData[1]} - ${rowData[2]}`);
        },
        serverSide: true,
        count: Number(count) || 1,
        page: Number(page) || 0,
        rowsPerPage,
        rowsPerPageOptions: [10, 25, 100, 500],
        jumpToPage: true,
        textLabels: {
            pagination: {
                next: "Next Page",
                previous: "Previous Page",
                rowsPerPage: "Total Items Per Page",
                displayRows: "OF",
            },
        },
        pagination: true,
        onChangePage: onChangePageEvent,
        onChangeRowsPerPage: onChangeRowsEvent,
        onFilterChange: onChangeFilterEvent,
        onColumnSortChange: onColumnSortChangeEvent,
    };
};

// ✅ Define PropTypes for better type safety
TableOptionsComponent.propTypes = {
    filename: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    setHeaderTitle: PropTypes.func.isRequired,
    onChangePageEvent: PropTypes.func.isRequired,
    onChangeRowsEvent: PropTypes.func.isRequired,
    onChangeFilterEvent: PropTypes.func.isRequired,
    onColumnSortChangeEvent: PropTypes.func.isRequired,
};

export default TableOptionsComponent;
